import { render } from "./QrcodeComp.vue?vue&type=template&id=18fd03e0&scoped=true"
import script from "./QrcodeComp.vue?vue&type=script&lang=js"
export * from "./QrcodeComp.vue?vue&type=script&lang=js"

import "./QrcodeComp.vue?vue&type=style&index=0&id=18fd03e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fd03e0"]])

export default __exports__